// extracted by mini-css-extract-plugin
export var locationCard = "_ev-0";